import React, { ReactNode } from 'react' 
import { DialogManager } from '../fasades/dialogmanager';
import { Users } from '../fasades/users';
import { CopyText } from '../fields/copytext';
import './newapikey.css';

enum Mode {
    CreateKey,
    SaveYourKey
};

type ApiKeyInfo = {
    name    : string;
    mode    : Mode;
    apiKey? : string;
};


type ApiKeyProps = {
    onCancel?  : () => void;
    onSave?    : (data: ApiKeyInfo) => void;
};

export class ApiKeyDialog extends React.Component<ApiKeyProps, ApiKeyInfo> {
    dialogRef = React.createRef<HTMLDialogElement>();

    constructor(props: ApiKeyProps) {
        super(props);
        this.state = {
            'mode' : Mode.CreateKey,
            'name' : ''
        };
    }

    componentDidMount() {
        // Show the dialog when the component mounts
        if (this.dialogRef.current) {
            this.dialogRef.current.showModal();
        }
    }

    handleCancel()
    {
        if (this.props.onCancel) {
            this.props.onCancel();
        }

        this.handleClose();
    }

    handleClose()
    {
        if (this.dialogRef.current) {
            this.dialogRef.current.close();
        }
        DialogManager.close();
    }

    handleChange(e : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)
    {
        if (e.target.name === "name") {
            this.setState({ name : e.target.value });
        }
    }

    async handleNewModel()
    {
        try {
            const apiKey = await Users.createApiKey(this.state.name);
            Users.getState();

            this.setState({
                'apiKey' : apiKey.token,
                'mode'   : Mode.SaveYourKey
            });
        }
        catch(e) {
        }
    };

    render() {
        return (
          <dialog ref={this.dialogRef} className="dialogStyle">
            { this.state.mode === Mode.CreateKey   && this.renderCreateKey() }
            { this.state.mode === Mode.SaveYourKey && this.renderSaveYourKey() }
          </dialog>
        );
    }

    renderCreateKey() : ReactNode
    {
        return (
          <>
            <div className="dialog-title">
              <h2 style={{marginTop: 0}}>New API Key</h2>
            </div>
            <form method="dialog" onSubmit={e => e.preventDefault()}>
              <label className="labelStyle" htmlFor="name">Name</label>
              <input
                className="inputStyle"
                id="name"
                name="name"
                type="text"
                value={this.state.name}
                onChange={(e) => this.handleChange(e) }
                placeholder="Enter a name"
                required
              />

              <div className="buttonRowStyle">
                <button type="button" className="buttonStyle cancelStyle" onClick={() => this.handleCancel()}>
                  Cancel
                </button>
                <button type="button" className="buttonStyle saveStyle" onClick={() => this.handleNewModel()}>
                  Create API Key
                </button>
              </div>
            </form>
          </>
        );
    }

    renderSaveYourKey() : ReactNode
    {
        return (
          <>
            <h2 style={{marginTop: 0}}>Save Your Key</h2>
            <p className="info">⚠️Please keep your secret key in a secure place, as you will not be able to view it again. Protect it carefully—anyone with access to your API key can make requests on your behalf. If you lose your key, you will need to generate a new one.</p>
            <form method="dialog" onSubmit={e => e.preventDefault()}>
              <CopyText label="API Key" text={this.state.apiKey!}/>

              <div className="buttonRowStyle">
                <button type="button" className="buttonStyle saveStyle" onClick={() => this.handleClose()}>
                  Done
                </button>
              </div>
            </form>
          </>
        )
    }

    static showDialog() : Promise<ApiKeyInfo>
    {
        return new Promise((resolve, reject) => {
            DialogManager.open(
                <ApiKeyDialog
                    onSave={(data: ApiKeyInfo) => resolve(data)}
                    onCancel={() => reject(new Error("Cancelled!"))}/>
            );
        });
    }
}

